import { capitalize } from "lodash"

export function getFlatDepthReport(report: Record<string, unknown>) {
  let flatDepthReport: Record<string, unknown> = {}
  Object.entries(report).forEach(([key, value]) => {
    if (typeof value !== "object" && !Array.isArray(value)) {
      flatDepthReport[key] = value
    } else if (Array.isArray(value)) {
      const zoneValues = value.map((zone) => zone.value || zone)
      if (key.includes("Zone")) {
        const [prefix] = key.split("Zone")
        let [, suffix] = key.split("Zone")

        if (suffix !== "Entries") {
          suffix = suffix?.slice(0, -1)
        }

        // entries(진입 횟수)류 메트릭의 인덱스는 2부터 시작. 1은 없다.
        zoneValues.forEach((zoneValue, idx) => {
          flatDepthReport[`${prefix}Zone${idx + (suffix !== "Entries" ? 1 : 2)}${suffix}`] =
            zoneValue
        })
      } else if (key.includes("Effort")) {
        zoneValues.forEach((zoneValue, idx) => {
          for (const [effortKey, effortValue] of Object.entries(zoneValue)) {
            if (effortKey === "actionCode") {
              continue
            }
            flatDepthReport[`${key}${idx + 1}${capitalize(effortKey)}`] = effortValue
          }
        })
      }
    } else if (value) {
      // calculated metric의 경우 { name, value } 객체로 내려옴 - 재귀하지 않고 원래 key로 저장
      const valueObj = value as Record<string, unknown>
      if ("name" in valueObj && "value" in valueObj && Object.keys(valueObj).length === 2) {
        flatDepthReport[key] = value
      } else {
        const flatValue = getFlatDepthReport(value as Record<string, unknown>)

        flatDepthReport = { ...flatDepthReport, ...flatValue }

        if (key === "summary") {
          flatDepthReport.summary = value
        }
      }
    }
  })

  return flatDepthReport
}
